// The resolver rejects any mutation naming a parent it was not also sent.
export const appendMissingParentInputs = (eventInputs, domainEvents) => {
  const present = new Set(eventInputs.map((input) => input.id))

  for (const input of [...eventInputs]) {
    for (const parentId of input.parents || []) {
      if (parentId === 'start' || present.has(parentId)) {
        continue
      }
      const index = domainEvents.findIndex((event) => event.id === parentId)
      if (index === -1) {
        continue
      }
      present.add(parentId)
      eventInputs.push({
        id: parentId,
        index,
        expectedVersion: domainEvents[index].version || undefined
      })
    }
  }

  return eventInputs
}
